import { HTMLAttributes, ReactNode } from 'react';

export interface ProfileContextProps {
  currentView?: ProfilePages;
}

export enum ProfilePages {
  Home = '',
  Commerciaux = 'commerciaux',
  Historique = 'historique',
  Receipts = 'receipts',
  Prospect = 'prospects',
  Consultations = 'consultations',
  Facturation = 'facturation',
  Profile = 'profil',
  Creadentials = 'credentials',
  Password = 'password',
  Company = 'company',
  Entity = 'entity',
  SubUsers = 'SubUsers',
}

export interface ProfileLayoutProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}
